// Api
import api from '../Base';

// Types
import { TimeRangeContextType } from "../../context/TimeRangeContext";
import { showError } from '../../utils/showAlert';
import { buildApiQuery } from '../../helpers/timeRangeUtils';

const fetchData = async (
        instanceId: number,
        path: string,
        timeRangeContext: TimeRangeContextType,
        errorMessage: string,
        extraParams: Record<string, string> = {}
): Promise<any[]> => {
    // Filter out undefined values from extraParams
    const filteredParams = Object.fromEntries(
        Object.entries(extraParams).filter(([_, value]) => value !== undefined)
    );

    const searchParams = new URLSearchParams({
        id: instanceId.toString(),
        ...filteredParams,
        ...Object.fromEntries(new URLSearchParams(buildApiQuery(timeRangeContext.timeRange))),
    });

    const url = `${path}?${searchParams.toString()}`;

    try {
        const response = await api.get<any[]>(url);
        if (response.status === 200 && response.data.length > 0) {
            return response.data;
        }
    } catch (error: any) {
        console.error(errorMessage, error, timeRangeContext);
        showError(errorMessage, error.message || error.toString());
    }

    return [];
};

const ObjectTuningApi = {
    getObjectAnalysis: (ctx: TimeRangeContextType, instanceId: number, selectedItem?: any) =>
            fetchData(instanceId, "object/analysis", ctx, "Failed to retrieve object analysis.", selectedItem ? { tablename: selectedItem.tablename, indexschema: selectedItem.indexschema, tableschema: selectedItem.tableschema, database: selectedItem.database, indexname: selectedItem.indexname} : undefined),

    getAnalysisType: (ctx: TimeRangeContextType, instanceId: number) =>
            fetchData(instanceId, "analysis/type", ctx, "Failed to retrieve analysis type."),

    getTableStatistic: (ctx: TimeRangeContextType, instanceId: number, selectedItem?: any) =>
            fetchData(instanceId, "table/statistic", ctx, "Failed to retrieve table statistic.", selectedItem ? { tablename: selectedItem.tablename, tableschema: selectedItem.tableschema, database: selectedItem.database} : { limit: '1000', sort: 'tablesizebytes desc' }),

    getIndexStatistic: (ctx: TimeRangeContextType, instanceId: number, selectedItem?: any) =>
            fetchData(instanceId, "index/statistic", ctx, "Failed to retrieve index statistic.", selectedItem ? { tablename: selectedItem.tablename, indexschema: selectedItem.indexschema, database: selectedItem.database} : { limit: '1000', sort: 'indexsizebytes desc' }),

    getTableColumns: (ctx: TimeRangeContextType, instanceId: number, tablename: string, tableschema: string, database: string) =>
            fetchData(instanceId, "table/column/statistic", ctx, "Failed to retrieve table columns.", { tablename, tableschema, database}),

    getIndexColumns: (ctx: TimeRangeContextType, instanceId: number, indexname: string, indexschema: string, database: string, tablename: string, tableschema: string) =>
            fetchData(instanceId, "index/column/statistic", ctx, "Failed to retrieve index columns.", { indexname, indexschema, database, tablename, tableschema }),
};

export default ObjectTuningApi;
